var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.loaded
          ? _c(
              "div",
              _vm._l(_vm.items, function(item, index) {
                return _c("div", { key: index }, [
                  item.longDescription != ""
                    ? _c("div", [
                        _vm.showImage
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    _vm.basedir +
                                    item.urlPrefix +
                                    item.url.split("?")[0]
                                }
                              },
                              [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value:
                                        item.imageUrl.indexOf("http") < 0
                                          ? _vm.basedir +
                                            item.imageUrl +
                                            "?w=285&quality=100"
                                          : item.imageUrl +
                                            "?w=285&quality=100",
                                      expression:
                                        "item.imageUrl.indexOf('http') < 0 ? basedir + item.imageUrl+'?w=285&quality=100' : item.imageUrl+'?w=285&quality=100'"
                                    }
                                  ],
                                  attrs: { alt: item.headers }
                                }),
                                typeof item.section != "undefined" &&
                                item.section.length != 0
                                  ? _c("p", { staticClass: "typeBadge" }, [
                                      _vm._v(_vm._s(item.section))
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            staticClass: "headline",
                            attrs: {
                              href:
                                _vm.basedir +
                                item.urlPrefix +
                                item.url.split("?")[0]
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.headers.length > 50
                                  ? item.headers.slice(0, 50) + "..."
                                  : item.headers
                              )
                            )
                          ]
                        ),
                        _c("p", { staticClass: "date" }, [
                          _vm._v(
                            _vm._s(
                              new Date(item.publicationDate)
                                .toLocaleDateString(_vm.locale, {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric"
                                })
                                .replace(/\./g, "-")
                            )
                          )
                        ]),
                        _c("p", { staticClass: "excerpt" }, [
                          _vm._v(
                            _vm._s(
                              item.description.length > 100
                                ? item.description.slice(0, 100) + "..."
                                : item.description
                            )
                          )
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "readMore",
                            attrs: {
                              href:
                                _vm.basedir +
                                item.urlPrefix +
                                item.url.split("?")[0]
                            }
                          },
                          [
                            _c("webmessage", {
                              attrs: {
                                searchKey: "wsm_ReadMore",
                                text: _vm.$root.language.wsm_ReadMore
                              }
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "angle-right"] }
                            })
                          ],
                          1
                        ),
                        _c("hr")
                      ])
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e()
      ]),
      !_vm.loaded
        ? _c(
            "div",
            _vm._l(_vm.resultNo, function(n) {
              return _c(
                "div",
                { key: n, staticClass: "loadContainer" },
                [
                  _vm.showImage
                    ? _c(
                        "vue-content-loading",
                        {
                          attrs: {
                            rtl: true,
                            width: 20000,
                            height: 12000,
                            speed: 1
                          }
                        },
                        [
                          _c("rect", {
                            attrs: {
                              x: "75",
                              y: "13",
                              rx: "4",
                              ry: "4",
                              width: "100%",
                              height: "100%"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "vue-content-loading",
                    {
                      attrs: { rtl: true, width: 20000, height: 3000, speed: 1 }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    { attrs: { rtl: true, width: 500, height: 32, speed: 1 } },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    { attrs: { rtl: true, width: 400, height: 31, speed: 1 } },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    { attrs: { rtl: true, width: 600, height: 32, speed: 1 } },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    ]
                  ),
                  _c(
                    "vue-content-loading",
                    {
                      staticStyle: {
                        "margin-top": "-10px",
                        "margin-bottom": "-8px"
                      },
                      attrs: { rtl: true, width: 175, height: 29, speed: 1 }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "75",
                          y: "13",
                          rx: "4",
                          ry: "4",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    ]
                  ),
                  _c("hr")
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }